import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { sa } from '../superAdminUi';

// A searchable single-select used by the Group and School forms.
//
// Options may be plain strings (value === label) or { value, label } objects, so the
// same component backs the country list (strings) and the data-storage-location list
// (value/label pairs). `value` is the raw stored value; `onChange(newValue)` returns
// the raw value (or null when cleared).

// Tokenised field styling so it matches the rest of the wizard inputs.
const fieldSx = {
  fontFamily: sa.font.family,
  '& .MuiOutlinedInput-root': { borderRadius: sa.radius.sm, fontFamily: sa.font.family },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: sa.color.stroke },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: sa.color.teal },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: sa.color.teal },
  '& .MuiInputLabel-root.Mui-focused': { color: sa.color.teal },
};

export default function SearchableSelect({
  label,
  value,
  onChange,
  options = [],
  placeholder,
  disabled = false,
  error = false,
  helperText,
  size = 'medium',
  fullWidth = true,
}) {
  const normalized = options.map((opt) =>
    typeof opt === 'object' && opt !== null ? opt : { value: opt, label: String(opt) }
  );

  const selected =
    value === null || value === undefined || value === ''
      ? null
      : normalized.find((opt) => opt.value === value) || { value, label: String(value) };

  return (
    <Autocomplete
      options={normalized}
      value={selected}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      getOptionLabel={(opt) => (opt ? opt.label : '')}
      isOptionEqualToValue={(opt, val) => opt.value === val.value}
      onChange={(_event, newValue) => onChange(newValue ? newValue.value : null)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          sx={fieldSx}
        />
      )}
    />
  );
}
